import { Dialog } from "primereact/dialog";
import { FC, useEffect, useState } from "react";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { Dropdown } from "primereact/dropdown";
import RawMaterialService, { getQualityChecksByPurchaseId } from "../../services/RawMaterials/RawMaterialService";
import { Toast } from "primereact/toast";
import { useRef } from "react";
import { FileUpload } from "primereact/fileupload";
import { useNavigate } from 'react-router-dom';
import { RawMaterialPurchaseListDTO } from "../../models/RawMaterials/RawMaterial-model";

interface QualityCheckFormProps {
  visible: boolean;
  onHide: () => void;
  rawMaterial: { name?: string; rawMaterialPurchaseId?: number; remainingQuantity?: number } | null;
  onSaveSuccess?: (updatedMaterial: RawMaterialPurchaseListDTO) => void;
}

interface QualityCheckDTO {
  qualityCheckId: number;
  qualityCheckName: string;
}

const QualityCheckForm: FC<QualityCheckFormProps> = ({ visible, onHide, rawMaterial, onSaveSuccess }) => {
  const [qualityCheckItems, setQualityCheckItems] = useState<QualityCheckDTO[]>([]);
  const [errors, setErrors] = useState<{ [key: number]: string }>({});
  const [comments, setComments] = useState("");
  const [commentError, setCommentError] = useState("");
  const [loading, setLoading] = useState(false);
  const [imageFile, setImageFile] = useState<File | null>(null);
  const [invoicedQuantity, setInvoicedQuantity] = useState<number | null>(null);
  const [remainingQuantity, setRemainingQuantity] = useState<number | null>(null);

  const [acceptedQuantity, setAcceptedQuantity] = useState<number | null>(null);
  const [acceptedQuantityInput, setAcceptedQuantityInput] = useState<string>("");

  const [rejectedQuantity, setRejectedQuantity] = useState<number | null>(null);
  const [rejectedQuantityInput, setRejectedQuantityInput] = useState<string>("");

  const [quantityError, setQuantityError] = useState<string>("");
  const [hoveredField, setHoveredField] = useState<string | null>(null);
  const [qaValues, setQaValues] = useState<{ [key: number]: string | number | boolean }>({});

  const [saving, setSaving] = useState(false);

  const navigate = useNavigate();
  const toast = useRef<Toast>(null);

  const toleranceRanges: { [key: string]: { min: number; max: number } } = {
    moisture: { min: 1.0, max: 10.0 },
    purity: { min: 6.1, max: 8.5 },
  };

  const fieldHoverStyle = (fieldName: string, hasError: boolean = false) => ({
    border: hasError
      ? "1px solid red"
      : hoveredField === fieldName
      ? "2px solid #076122ff"
      : "1px solid #ced4da",
    boxShadow:
      hoveredField === fieldName
        ? "0 0 6px rgba(7, 97, 34, 0.4)"
        : "none",
    transition: "all 0.2s ease-in-out",
    borderRadius: "4px",
    width: "100%",
  });

  useEffect(() => {
    const fetchQualityChecks = async () => {
      if (!rawMaterial?.rawMaterialPurchaseId) return;
      setLoading(true);
      try {
        const data = await getQualityChecksByPurchaseId(rawMaterial.rawMaterialPurchaseId);
        if (data) {
          setQualityCheckItems(data.qualityChecks ?? []);
          // setInvoicedQuantity(data.invoicedQuantity ?? null);
          setInvoicedQuantity(data.invoicedQuantity ?? data.InvoicedQuantity ?? null);
          // prefer remaining coming from API; fallback to prop if provided
          const remaining = (data.remainingQuantity ?? rawMaterial?.remainingQuantity) ?? null;
          setRemainingQuantity(remaining);
          // prefill accepted input with remaining quantity (frontend-only)
          setAcceptedQuantity(remaining);
          setAcceptedQuantityInput(remaining ? String(remaining) : "");

        //   setRejectedQuantity(remaining);
        // setRejectedQuantityInput(remaining ? String(remaining) : "");

        setRejectedQuantity(0);
setRejectedQuantityInput("0");

          setQaValues({});
          setErrors({});
          // setRejectedQuantityInput("");
          // setRejectedQuantity(null);
        } else {
          // fallback to prop values
          setInvoicedQuantity(null);
          setRemainingQuantity(rawMaterial?.remainingQuantity ?? null);
          const remaining = rawMaterial?.remainingQuantity ?? null;
          setAcceptedQuantity(remaining);
          setAcceptedQuantityInput(remaining ? String(remaining) : "");
        }
      } catch (error) {
        console.error("Error fetching quality checks:", error);
        setRemainingQuantity(rawMaterial?.remainingQuantity ?? null);
        const remaining = rawMaterial?.remainingQuantity ?? null;
        setAcceptedQuantity(remaining);
        setAcceptedQuantityInput(remaining ? String(remaining) : "");
      } finally {
        setLoading(false);
      }
    };

    if (visible) {
      fetchQualityChecks();
    }
  }, [visible, rawMaterial?.rawMaterialPurchaseId, rawMaterial?.remainingQuantity]);

  

  const handleInputChange = (id: number, name: string, value: string | boolean) => {
    setQaValues((prev) => ({ ...prev, [id]: value }));

    let errorMsg = "";
    const lowerName = name.toLowerCase();

    if (value === "" || value === null || value === undefined) {
      errorMsg = `${name} is required`;
    } else if (typeof value === "string" && lowerName.includes("moisture")) {
      if (value.includes('.') && value.split('.')[1]?.length > 2) {
        errorMsg = `${name} invalid value`;
      } else {
        const numericVal = parseFloat(value);
        const range = toleranceRanges["moisture"];
        if (isNaN(numericVal) || numericVal < range.min || numericVal > range.max) {
          errorMsg = `${name} must be between ${range.min} and ${range.max}`;
        }
      }
    }


    setErrors((prev) => {
      if (errorMsg) {
        return { ...prev, [id]: errorMsg };
      } else {
        const { [id]: _, ...rest } = prev;
        return rest;
      }
    });
  };

  const handleCommentChange = (value: string) => {
    setComments(value);
    setCommentError("");
  };

  const hasFail = Object.values(qaValues).includes("Fail");

  // useEffect(() => {
  //   if (hasFail) {
  //     setAcceptedQuantity(null);
  //     setAcceptedQuantityInput("");
  //   } else {


  //     const defaultAccepted =
  //     remainingQuantity ?? invoicedQuantity ?? null;

  //     setRejectedQuantity(null);
  //     setRejectedQuantityInput("");
  //     setRejectedQuantity(null);
  //   setRejectedQuantityInput("");
  //   setAcceptedQuantity(defaultAccepted);
  //   setAcceptedQuantityInput(defaultAccepted ? String(defaultAccepted) : "");
  //   }
  //   setQuantityError("");
  // }, [hasFail]);

  //


  useEffect(() => {
  if (hasFail) {
    setAcceptedQuantity(0);
    setAcceptedQuantityInput("0");
    const defaultRejected = remainingQuantity ?? 0;
    setRejectedQuantity(defaultRejected);
    setRejectedQuantityInput(defaultRejected ? String(defaultRejected) : "0");
  } else {
    const defaultAccepted = remainingQuantity ?? 0;
    setAcceptedQuantity(defaultAccepted);
    setAcceptedQuantityInput(defaultAccepted ? String(defaultAccepted) : "0");
    setRejectedQuantity(0);
    setRejectedQuantityInput("0");
  }
  setQuantityError("");
}, [hasFail, remainingQuantity]);

  const maxAllowed = () => {
    // max a single accepted/rejected input can have is min(invoiced, remaining) if remaining present
    if (invoicedQuantity === null && remainingQuantity === null) return null;
    if (invoicedQuantity === null) return remainingQuantity;
    if (remainingQuantity === null) return invoicedQuantity;
    return Math.min(invoicedQuantity, remainingQuantity);
  };

  const validateAcceptedQtyInput = (inputValue: string) => {
    if (inputValue === "") {
      setQuantityError("Accepted Quantity is required");
      setAcceptedQuantity(null);
      return false;
    }
    const numericValue = parseFloat(inputValue);
    if (isNaN(numericValue)) {
      setQuantityError("Accepted Quantity must be a number");
      setAcceptedQuantity(null);
      return false;
    }

    const max = maxAllowed();
    if (max !== null && numericValue > max) {
      setQuantityError(`Accepted Quantity cannot exceed remaining (${max}) or invoiced quantity`);
      setAcceptedQuantity(numericValue);
      return false;
    }
    if (numericValue < 0) {
      setQuantityError("Accepted Quantity cannot be negative");
      setAcceptedQuantity(numericValue);
      return false;
    }


    // if rejected is present ensure sum doesn't exceed remaining/invoiced
    // const rej = rejectedQuantity ?? (rejectedQuantityInput ? parseFloat(rejectedQuantityInput) : 0);
    // const total = numericValue + (isNaN(rej) ? 0 : rej);
    // const limit = maxAllowed();
    // if (limit !== null && total > limit) {
    //   setQuantityError("Accepted + Rejected cannot exceed remaining or invoiced quantity");
    //   setAcceptedQuantity(numericValue);
    //   return false;
    // }

      if (numericValue <= 0) {
    setQuantityError("Accepted Quantity cannot be zero or negative");
    setAcceptedQuantity(numericValue);
    return false;
  }

    setQuantityError("");
    setAcceptedQuantity(numericValue);
    return true;
  };

  const validateRejectedQtyInput = (inputValue: string) => {
    if (inputValue === "") {
      setQuantityError("Rejected Quantity is required");
      setRejectedQuantity(null);
      return false;
    }
    const numericValue = parseFloat(inputValue);
    if (isNaN(numericValue)) {
      setQuantityError("Rejected Quantity must be a number");
      setRejectedQuantity(null);
      return false; 
    }
    const max = maxAllowed();
    if (max !== null && numericValue > max) {
      setQuantityError(`Rejected Quantity cannot exceed remaining (${max}) or invoiced quantity`);
      setRejectedQuantity(numericValue);
      return false;
    }
    if (numericValue < 0) {
      setQuantityError("Rejected Quantity cannot be negative");
      setRejectedQuantity(numericValue);
      return false;
    }
    // if accepted is present ensure sum doesn't exceed remaining/invoiced
    // const acc = acceptedQuantity ?? (acceptedQuantityInput ? parseFloat(acceptedQuantityInput) : 0);
    // const total = numericValue + (isNaN(acc) ? 0 : acc);
    // const limit = maxAllowed();
    // if (limit !== null && total > limit) {
    //   setQuantityError("Accepted + Rejected cannot exceed remaining or invoiced quantity");
    //   setRejectedQuantity(numericValue);
    //   return false;
    // }

     if (numericValue <= 0) {
    setQuantityError("Rejected Quantity cannot be zero or negative");
    setRejectedQuantity(numericValue);
    return false;
  }

    setQuantityError("");
    setRejectedQuantity(numericValue);
    return true;
  };

  const handleSave = async (isAccepted: boolean) => {
    if (!rawMaterial?.rawMaterialPurchaseId) return;



     if (saving) return;
    setSaving(true);

    const localErrors: { [key: number]: string } = {};
    qualityCheckItems.forEach((item) => {
      const value = qaValues[item.qualityCheckId];
      if (value === undefined || value === null || value === "") {
        localErrors[item.qualityCheckId] = `${item.qualityCheckName} is required`;
      }
    });

    setErrors((prev) => ({ ...prev, ...localErrors }));

    let qtyValid = true;
    if (isAccepted) {
      qtyValid = validateAcceptedQtyInput(acceptedQuantityInput);
    } else {
      qtyValid = validateRejectedQtyInput(rejectedQuantityInput);
    }

    if (isAccepted) {
  qtyValid = validateAcceptedQtyInput(acceptedQuantityInput);
  // When accepting, rejected should be 0
  setRejectedQuantity(0);
  setRejectedQuantityInput("0");
} else {
  qtyValid = validateRejectedQtyInput(rejectedQuantityInput);
  // When rejecting, accepted should be 0
  setAcceptedQuantity(0);
  setAcceptedQuantityInput("0");
}



    if (
      Object.keys(localErrors).length > 0 ||
      Object.keys(errors).length > 0 ||
      !!commentError ||
      !qtyValid
    ) {
      toast.current?.show({
        severity: "error",
        summary: "Failed",
        detail: isAccepted ? "Please enter the Accepted Quantity before accepting." : "Please enter the Rejected Quantity before rejecting.",
        life: 3000,
      });

 setSaving(false);
return;
    }

    const primaryPayload = [
      {
        rawMaterialPurchaseID: rawMaterial.rawMaterialPurchaseId,
        qualityCheckID: qualityCheckItems.map(item => item.qualityCheckId),
        qaValue: qualityCheckItems.map(item => {
          const value = qaValues[item.qualityCheckId];
          if (typeof value === "number") return (value as number).toFixed(2);
          const numeric = parseFloat(value as string);
          if (!isNaN(numeric)) return numeric.toFixed(2);
          return value ?? "";
        }),
        qaResult: isAccepted,
        comments: comments || "",
        acceptedQuantity: isAccepted ? (acceptedQuantity ?? invoicedQuantity ?? 0) : 0,
        rejectedQuantity: isAccepted ? 0 : (rejectedQuantity ?? 0)
      }
    ];

    try {
      const response = await RawMaterialService.saveQualityCheckResults(primaryPayload);
      toast.current?.show({
        severity: "success",
        summary: "Updated Successfully",
        detail: response?.message || "Updated Successfully",
        life: 3000,
      });
    } catch (err) {
      console.error("Error saving quality check results:", err);
      toast.current?.show({
        severity: "error",
        summary: "Failed",
        detail: "Failed",
        life: 3000,
      });
      return;
    }

    // Secondary payload for SaveQualityCheckResultsofRejected endpoint (still call but suppress success toast)
    try {
      const currentUserId =
        (() => {
          try {
            const u = localStorage.getItem("user");
            if (u) {
              const parsed = JSON.parse(u);
              return parsed?.userId ?? parsed?.userID ?? parsed?.id ?? 0;
            }
          } catch { /* ignore */ }
          const alt = localStorage.getItem("userId") || localStorage.getItem("userid") || localStorage.getItem("userID");
          return alt ? Number(alt) : 0;
        })() || 0;

      const today = new Date().toISOString().split("T")[0]; // YYYY-MM-DD

      const secondaryPayload = [
        {
          rawMaterialPurchaseID: rawMaterial.rawMaterialPurchaseId,
          quantity: isAccepted ? (acceptedQuantity ?? invoicedQuantity ?? 0) : (rejectedQuantity ?? 0),
          qcStatus: !!isAccepted,
          note: comments || "",
          createdBy: currentUserId,
          createdDate: today,
          updatedBy: currentUserId,
          updatedDate: today
        }
      ];

      await RawMaterialService.SaveQualityCheckResultsofRejected(secondaryPayload);
      // do not show success toast for secondary endpoint
    } catch (secErr) {
      console.error("Error saving secondary QC status:", secErr);
      toast.current?.show({
        severity: "error",
        summary: "Failed",
        detail: "Failed",
        life: 3500,
      });
    }

    if (onSaveSuccess && rawMaterial) onSaveSuccess(rawMaterial as RawMaterialPurchaseListDTO);
    onHide();
  };
 

  const handleImageUpload = (event: any) => {
    if (event.files && event.files.length > 0) {
      setImageFile(event.files[0]);
      toast.current?.show({
        severity: "success",
        summary: "Updated Successfully",
        detail: `${event.files[0].name} added successfully.`,
        life: 3000,
      });
    }
  };

  const handleImageRemove = () => {
    setImageFile(null);
    toast.current?.show({
      severity: "success",
      summary: "Updated Successfully",
      detail: "Image removed.",
      life: 2000,
    });
  };

  const hasValidationErrors =
    Object.keys(errors).length > 0 ||
    qualityCheckItems.some(item => {
      const value = qaValues[item.qualityCheckId];
      return value === undefined || value === null || value === "";
    }) ||
    !!commentError ||
    quantityError !== "";

  const hasMoistureError = Object.entries(errors).some(([id, msg]) =>
    msg.toLowerCase().includes("moisture")
  );

  useEffect(() => {
    if (visible) {
      setQaValues({});
      setErrors({});
      setComments("");
      setCommentError("");
      setAcceptedQuantity(null);
      setAcceptedQuantityInput("");
      setRejectedQuantity(null);
      setRejectedQuantityInput("");
      setImageFile(null);
      setQuantityError("");
      // reset remaining from prop when dialog reopens
      setRemainingQuantity(rawMaterial?.remainingQuantity ?? null);
      // prefill accepted input from remaining prop if available
      const remaining = rawMaterial?.remainingQuantity ?? null;
      setAcceptedQuantity(remaining);
      setAcceptedQuantityInput(remaining ? String(remaining) : "");
    }
  }, [visible, rawMaterial?.remainingQuantity]);

  const handleDialogHide = () => {
    setQaValues({});
    setErrors({});
    setComments("");
    setCommentError("");
    setAcceptedQuantity(null);
    setAcceptedQuantityInput("");
    setRejectedQuantity(null);
    setRejectedQuantityInput("");
    setImageFile(null);
    setQuantityError("");
    onHide();
  };

  const acceptDisabled = hasFail || hasValidationErrors || hasMoistureError;
  const rejectDisabled = !hasFail || hasValidationErrors || hasMoistureError;



  useEffect(() => {
  if (!visible) return;

  // Full reset every time modal opens or new raw material is selected
  setQaValues({});
  setErrors({});
  setComments("");
  setCommentError("");
  setAcceptedQuantity(null);
  setAcceptedQuantityInput("");
  setRejectedQuantity(null);
  setRejectedQuantityInput("");
  setImageFile(null);
  setQuantityError("");

  // Reset quality-check-related states
  setLoading(false);
  setSaving(false);

  // Reset flags that may affect Accept/Reject buttons
  setHoveredField(null);

  // Reset quantities based on current raw material
  const remaining = rawMaterial?.remainingQuantity ?? null;
  setRemainingQuantity(remaining);
  setAcceptedQuantity(remaining);
  setAcceptedQuantityInput(remaining ? String(remaining) : "");

}, [visible, rawMaterial?.rawMaterialPurchaseId]);


  return (
    <div>
      <Toast ref={toast} />
      <Dialog
        header={`QUALITY CHECK FOR: ${rawMaterial?.name ?? ""}`}
        visible={visible}
        style={{ width: "40vw" }}
        draggable={false}
        onHide={handleDialogHide}
        footer={
          <div className="p-d-flex p-jc-end" style={{ gap: "1rem" }}>
            <Button
              label="Accept"
              icon="pi pi-check"
              className="p-button-success"
              onClick={() => handleSave(true)}
              // disabled={acceptDisabled|| saving}
               disabled={saving || acceptDisabled === true}
            />
            <Button
              label="Reject"
              icon="pi pi-times"
              className="p-button-danger"
              onClick={() => handleSave(false)}
              disabled={rejectDisabled}
            />
          </div>
        }
      >
        <div className="p-fluid">
          {loading ? (
            <p>Loading quality checks...</p>
          ) : (
            qualityCheckItems.map((item) => {
              const isTextField = item.qualityCheckName.toLowerCase().includes("moisture");

              return (
                <div className="p-field p-grid" key={item.qualityCheckId} style={{ marginBottom: "1rem" }}>
                  <label htmlFor={`qc-${item.qualityCheckId}`} className="p-col-5" style={{ fontWeight: 500 }}>
                    {item.qualityCheckName}<span style={{ color: "red" }}>*</span>
                  </label>
                  <div className="p-col-7">
                    {isTextField ? (
                      <>
                        <InputText
                          id={`qc-${item.qualityCheckId}`}
                          onMouseLeave={() => setHoveredField(null)}
                          value={(qaValues[item.qualityCheckId] as string) || ""}
                          onChange={(e) =>
                            handleInputChange(item.qualityCheckId, item.qualityCheckName, e.target.value)
                          }
                          onMouseEnter={() => setHoveredField(item.qualityCheckId.toString())}
                          style={fieldHoverStyle(
                            item.qualityCheckId.toString(),
                            !!errors[item.qualityCheckId]
                          )}
                        />
                        {errors[item.qualityCheckId] && (
                          <small style={{ color: "red" }}>{errors[item.qualityCheckId]}</small>
                        )}
                      </>
                    ) : (
                      <Dropdown
                        id={`qc-${item.qualityCheckId}`}
                        value={qaValues[item.qualityCheckId] ?? ""}
                        options={[
                          { label: "Pass", value: "Pass" },
                          { label: "Fail", value: "Fail" },
                          { label: "NA", value: "NA" },
                        ]}
                        onChange={(e) => handleInputChange(item.qualityCheckId, item.qualityCheckName, e.value)}
                        placeholder="Select"
                        onMouseEnter={() => setHoveredField(item.qualityCheckId.toString())}
                        onMouseLeave={() => setHoveredField(null)}
                        style={fieldHoverStyle(item.qualityCheckId.toString())}
                      />
                    )}
                  </div>
                </div>
              );
            })
          )}

          <div className="p-field p-grid" style={{ marginTop: "1rem" }}>
            <label htmlFor="comments" className="p-col-5" style={{ fontWeight: 500 }}>
              Comments
            </label>
            <div className="p-col-7">
              <InputText
                id="comments"
                value={comments}
                onChange={(e) => handleCommentChange(e.target.value)}
                placeholder="Enter comments"
                style={{
                  border: "1px solid #ccc",
                  padding: "0.5rem",
                  borderRadius: "4px",
                  width: "100%",
                }}
              />
              {commentError && <small style={{ color: "red" }}>{commentError}</small>}
            </div>
          </div>

          {invoicedQuantity !== null && (
            <div className="p-field p-grid" style={{ marginBottom: "1rem" }}>
              <label className="p-col-5" style={{ fontWeight: 500 }}>
                Invoiced Quantity
              </label>
              <div className="p-col-7">
                <InputText
                  value={invoicedQuantity.toString()}
                  readOnly
                  onMouseEnter={() => setHoveredField("invoicedQuantity")}
                  onMouseLeave={() => setHoveredField(null)}
                  style={{
                    border: "1px solid #ccc",
                    padding: "0.5rem",
                    borderRadius: "4px",
                    width: "100%",
                    ...(hoveredField === "invoicedQuantity"
                      ? { borderColor: "grey", boxShadow: "0 0 5px rgba(0, 255, 47, 0.5)" }
                      : {}),
                  }}
                />
              </div>
            </div>
          )}
          {remainingQuantity !== null && (
          <div className="p-field p-grid" style={{ marginBottom: "1rem" }}>
            <label className="p-col-5" style={{ fontWeight: 500 }}>
              Remaining Quantity
            </label>
            <div className="p-col-7">
              <InputText
                value={remainingQuantity.toString()}
                readOnly
                onMouseEnter={() => setHoveredField("remainingQuantity")}
                onMouseLeave={() => setHoveredField(null)}
                style={{
                  border: "1px solid #ccc",
                  padding: "0.5rem",
                  borderRadius: "4px",
                  width: "100%",
                  backgroundColor: "#f9f9f9",
                  ...(hoveredField === "remainingQuantity"
                    ? { borderColor: "grey", boxShadow: "0 0 5px rgba(0, 255, 47, 0.5)" }
                    : {}),
                }}
              />
            </div>
          </div>
        )}
          {!hasFail ? (
            <div className="p-field p-grid" style={{ marginBottom: "1rem" }}>
              <label className="p-col-5" style={{ fontWeight: 500 }}>
                Accepted Quantity<span style={{ color: "red" }}>*</span>
              </label>
              <div className="p-col-7">
                <InputText
                  value={acceptedQuantityInput}
                  onChange={(e) => {
                    const inputValue = e.target.value;
                    if (/^\d*\.?\d*$/.test(inputValue)) {
                      setAcceptedQuantityInput(inputValue);
                      validateAcceptedQtyInput(inputValue);
                    }
                  }}
                  onKeyPress={(e) => {
                    if (!/[0-9.]/.test(e.key)) e.preventDefault();
                    if (e.key === "." && e.currentTarget.value.includes(".")) e.preventDefault();
                  }}
                  onMouseEnter={() => setHoveredField("acceptedQuantity")}
                  onMouseLeave={() => setHoveredField(null)}
                  style={{
                    border: quantityError ? "1px solid red" : "1px solid #ccc",
                    padding: "0.5rem",
                    borderRadius: "4px",
                    width: "100%",
                  }}
                />
                {quantityError && <small style={{ color: "red" }}>{quantityError}</small>}
              </div>
            </div>
          ) : (
            <div className="p-field p-grid" style={{ marginBottom: "1rem" }}>
              <label className="p-col-5" style={{ fontWeight: 500 }}>
                Rejected Quantity<span style={{ color: "red" }}>*</span>
              </label>
              <div className="p-col-7">
                <InputText
                  value={rejectedQuantityInput}
                  onChange={(e) => {
                    const inputValue = e.target.value;
                    if (/^\d*\.?\d*$/.test(inputValue)) {
                      setRejectedQuantityInput(inputValue);
                      validateRejectedQtyInput(inputValue);
                    }
                  }}
                  onKeyPress={(e) => {
                    if (!/[0-9.]/.test(e.key)) e.preventDefault();
                    if (e.key === "." && e.currentTarget.value.includes(".")) e.preventDefault();
                  }}
                  onMouseEnter={() => setHoveredField("rejectedQuantity")}
                  onMouseLeave={() => setHoveredField(null)}
                  style={{
                    border: quantityError ? "1px solid red" : "1px solid #ccc",
                    padding: "0.5rem",
                    borderRadius: "4px",
                    width: "100%",
                  }}
                />
                {quantityError && <small style={{ color: "red" }}>{quantityError}</small>}
              </div>
            </div>
          )}

          <div className="p-field p-grid" style={{ marginTop: "1rem" }}>
            <label htmlFor="image" className="p-col-5" style={{ fontWeight: 500 }}>
              Upload Image
            </label>
            <div className="p-col-7">
              <FileUpload
                name="image"
                accept="image/*"
                maxFileSize={2000000}
                customUpload
                uploadHandler={handleImageUpload}
                onClear={handleImageRemove}
                chooseLabel="Select Image"
                auto
                mode="basic"
                className="p-button-outlined p-button-info"
              />
              {imageFile && (
                <small style={{ color: "green" }}>
                  {imageFile.name} selected
                </small>
              )}
            </div>
          </div>
        </div>
      </Dialog>
    </div>
  );
};

export default QualityCheckForm;